(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[30425,18740,31701,69655,14777,25591,84043,60681,65250,74206,52892],{

/***/ 21260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TopBusinessQuotesWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/footer/index.tsx
var footer = __webpack_require__(31701);
// EXTERNAL MODULE: ./src/components/shared/modal/index.tsx
var shared_modal = __webpack_require__(18740);
// EXTERNAL MODULE: ./src/components/svg/closeIcon.tsx
var closeIcon = __webpack_require__(69655);
// EXTERNAL MODULE: ./src/components/shared/legal/privacyPolicy.tsx + 1 modules
var privacyPolicy = __webpack_require__(57079);
// EXTERNAL MODULE: ./src/components/shared/legal/termsAndConditions.tsx + 1 modules
var termsAndConditions = __webpack_require__(10761);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
;// CONCATENATED MODULE: ./src/components/topbusinessquotes/logo/index.tsx


function TopBusinessQuotesLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "408",
        height: "67",
        fill: "none",
        viewBox: "0 0 408 67",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_260)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#063C58",
                        d: "M68.7 33.234h-6.54L58.728 57.66h-6.62l3.431-24.427H49l.777-5.082h19.659l-.737 5.082zM65.754 49.259c0-7.501 4.208-12.746 11.565-12.746 5.763 0 8.87 3.28 8.87 8.897 0 7.501-4.209 12.664-11.444 12.664-5.884 0-8.991-3.28-8.991-8.815zm14.098-3.727c0-2.54-1.06-4.018-3.188-4.018-3.108 0-4.58 4.059-4.58 7.5 0 2.582 1.141 4.019 3.148 4.019 3.107 0 4.62-3.937 4.62-7.5zM109.111 43.73c0 8.077-4.533 14.344-12.586 14.344-.534 0-1.31 0-2.168-.04l-1.27 9.059H86.75l4.168-29.678c1.27-.495 2.493-.902 3.844-.902 1.27 0 1.959.983 1.959 2.623 0 .244 0 .413-.04.82l-.122.941c1.837-3.157 3.925-4.384 6.58-4.384 2.857 0 5.965 2.297 5.965 7.217h.007zm-6.621 1.68c0-2.46-.696-3.896-2.33-3.896-1.919 0-3.844 2.087-4.702 8.483l-.453 3.32c.696.041 1.392.041 1.96.041 3.715 0 5.518-3.896 5.518-7.955l.007.007zM139.882 48.236c0 6.227-5.6 9.838-12.957 9.838-1.919 0-6.337-.162-9.194-.406l4.127-29.51h.041c3.513-.243 7.316-.406 9.194-.406 6.087 0 9.519 2.378 9.519 6.6 0 3.605-1.757 6.227-4.581 7.826 2.493 1.186 3.844 3.239 3.844 6.064l.007-.006zm-6.985.244c0-2.175-1.311-3.483-3.554-3.483h-3.229l-1.101 7.955c1.061.04 2 .04 2.777.04 3.188 0 5.107-1.965 5.107-4.506v-.006zm-2.777-15.66c-.614 0-1.391 0-2.29.041l-.979 7.047h1.878c3.067 0 4.823-1.64 4.823-4.303 0-1.72-1.101-2.785-3.432-2.785zM160.561 53.934c-.041.325-.081.78-.081 1.186 0 .698.081 1.396.405 1.884-1.432.657-2.655 1.064-4.087 1.064s-2.452-1.024-2.452-2.826c0-.244 0-.325.04-.739l.081-.9c-1.878 3.157-4.006 4.465-6.661 4.465-3.269 0-5.026-1.965-5.026-5.699 0-.576.041-1.227.122-1.924l1.878-13.037c1.223-.495 2.533-.901 3.803-.901 1.514 0 2.29.82 2.29 2.256 0 .163 0 .203-.04.535l-1.473 9.88a8.766 8.766 0 00-.121 1.314c0 1.396.324 2.541 1.756 2.541 2.371 0 3.716-2.087 4.661-8.524l1.02-7.094c1.27-.495 2.493-.902 3.763-.902 1.473 0 2.29.82 2.29 2.257 0 .162 0 .203-.04.535l-2.128 14.636v-.007zM181.847 39.014l-2.614 3.36c-1.554-.941-2.945-1.436-4.661-1.436-1.432 0-2.534.698-2.534 1.884 0 .982.98 1.517 2.453 2.046 2.945 1.064 6.046 2.378 6.046 5.942 0 4.838-4.087 7.258-9.032 7.258-3.148 0-5.844-.78-7.931-2.623l2.04-3.767c1.837 1.477 4.411 1.884 5.762 1.884 1.554 0 2.898-.576 2.898-1.884 0-1.105-1.391-1.68-2.857-2.175-2.574-.86-5.56-2.257-5.56-5.699 0-4.675 3.635-7.297 8.58-7.297 2.945 0 5.478.9 7.397 2.5l.013.007zM189.738 53.934c-.041.325-.081.78-.081 1.186 0 .698.081 1.396.405 1.884-1.432.657-2.614 1.064-4.087 1.064-1.797 0-2.655-1.024-2.655-2.785 0-.163 0-.326.041-.658l2.411-17.705h6.337l-2.371 17.007v.007zm-3.351-23.078c0-2.257 1.351-3.856 3.756-3.856 2 0 3.189 1.064 3.189 2.866 0 2.297-1.311 3.856-3.716 3.856-2.04 0-3.229-1.064-3.229-2.867zM212.781 53.934c-.041.325-.122.78-.122 1.186 0 .698.122 1.396.453 1.884-1.432.657-2.655 1.064-4.047 1.064-1.837 0-2.695-1.024-2.695-2.785 0-.163 0-.326.041-.658l1.391-9.222c.081-.535.122-.982.122-1.395 0-1.437-.453-2.5-1.878-2.5-2.574 0-4.128 2.994-5.189 10.244L200 57.654h-6.337l2.817-20.368c1.223-.495 2.452-.78 3.31-.78 1.716 0 2.493 1.315 2.493 3.117 0 .204 0 .244-.041.74l-.081 1.022c1.959-3.645 4.209-4.878 6.945-4.878 3.391 0 5.229 2.175 5.229 5.82 0 .617-.081 1.274-.162 1.843l-1.392 9.757v.007zM231.825 51.637l1.878 4.1c-2.493 1.599-5.269 2.337-8.255 2.337-5.479 0-8.458-3.076-8.458-8.442 0-7.38 4.208-13.119 11.444-13.119 4.492 0 6.944 2.257 6.944 5.943 0 5.536-4.621 7.582-10.093 7.582-.817 0-1.634-.04-2.411-.163.04 2.216.898 3.443 3.31 3.443s4.087-.698 5.641-1.68zm-8.62-5.204c.655.04 1.31.082 1.878.082 2.29 0 4.208-1.145 4.208-3.28 0-1.064-.614-1.802-1.878-1.802-2.249 0-3.634 2.134-4.208 5zM254.219 39.014l-2.614 3.36c-1.554-.941-2.945-1.436-4.661-1.436-1.432 0-2.534.698-2.534 1.884 0 .982.98 1.517 2.453 2.046 2.945 1.064 6.046 2.378 6.046 5.942 0 4.838-4.087 7.258-9.032 7.258-3.148 0-5.844-.78-7.931-2.623l2.04-3.767c1.837 1.477 4.411 1.884 5.762 1.884 1.554 0 2.898-.576 2.898-1.884 0-1.105-1.391-1.68-2.857-2.175-2.574-.86-5.56-2.257-5.56-5.699 0-4.675 3.635-7.297 8.58-7.297 2.945 0 5.478.9 7.397 2.5l.013.007zM272.689 39.014l-2.614 3.36c-1.554-.941-2.946-1.436-4.662-1.436-1.432 0-2.533.698-2.533 1.884 0 .982.98 1.517 2.452 2.046 2.946 1.064 6.046 2.378 6.046 5.942 0 4.838-4.087 7.258-9.032 7.258-3.148 0-5.843-.78-7.931-2.623l2.04-3.767c1.838 1.477 4.412 1.884 5.763 1.884 1.554 0 2.905-.576 2.905-1.884 0-1.105-1.392-1.68-2.858-2.175-2.574-.86-5.56-2.257-5.56-5.699 0-4.675 3.635-7.297 8.58-7.297 2.945 0 5.479.9 7.397 2.5l.007.007zM296.428 57.708l.121.698c.453 2.46 2.736 3.524 5.56 3.686l-3.432 4.425c-4.37-.454-7.316-3.158-8.376-6.966l-.494-1.761c-5.478-1.064-8.539-5.204-8.539-11.682 0-10.286 5.479-18.363 15.322-18.363 7.357 0 11.565 4.384 11.565 12.048 0 8.897-4.208 16.147-11.727 17.909v.006zm4.904-17.746c0-4.424-1.797-6.965-5.228-6.965-5.391 0-7.972 6.762-7.972 12.826 0 4.466 1.919 7.007 5.31 7.007 5.398 0 7.884-6.803 7.884-12.868h.006zM328.017 53.934c-.041.325-.081.78-.081 1.186 0 .698.081 1.396.412 1.884-1.432.657-2.655 1.064-4.087 1.064-1.433 0-2.453-1.024-2.453-2.826 0-.244 0-.325.041-.739l.081-.9c-1.878 3.157-4.006 4.465-6.661 4.465-3.27 0-5.026-1.965-5.026-5.699 0-.576.04-1.227.122-1.924l1.878-13.037c1.222-.495 2.533-.901 3.803-.901 1.513 0 2.29.82 2.29 2.256 0 .163 0 .203-.04.535l-1.473 9.88a8.784 8.784 0 00-.122 1.314c0 1.396.324 2.541 1.757 2.541 2.371 0 3.722-2.087 4.661-8.524l1.02-7.094c1.27-.495 2.493-.902 3.756-.902 1.473 0 2.29.82 2.29 2.257 0 .162 0 .203-.04.535l-2.128 14.636v-.007zM332.388 49.259c0-7.501 4.208-12.746 11.565-12.746 5.763 0 8.87 3.28 8.87 8.897 0 7.501-4.209 12.664-11.444 12.664-5.884 0-8.991-3.28-8.991-8.815zm14.098-3.727c0-2.54-1.06-4.018-3.188-4.018-3.108 0-4.58 4.059-4.58 7.5 0 2.582 1.141 4.019 3.148 4.019 3.107 0 4.62-3.937 4.62-7.5zM363.071 50.079c-.04.366-.04.616-.04.86 0 1.437.574 2.087 1.716 2.087 1.02 0 2.168-.284 2.904-.698l.406 4.676c-1.716.738-3.473 1.063-5.31 1.063-4.006 0-6.208-2.134-6.208-5.78 0-.413.04-.9.121-1.436l1.223-9.181h-2.736l.655-4.757h2.986l.655-4.716c1.142-.495 2.372-.82 3.311-.82 1.635 0 2.533 1.064 2.533 2.622 0 .163 0 .204-.041.495l-.364 2.42h5.31l-.615 4.756h-5.391l-1.101 8.402-.014.007zM385.547 51.637l1.878 4.1c-2.493 1.599-5.269 2.337-8.255 2.337-5.479 0-8.458-3.076-8.458-8.442 0-7.38 4.208-13.119 11.444-13.119 4.492 0 6.944 2.257 6.944 5.943 0 5.536-4.621 7.582-10.093 7.582-.817 0-1.634-.04-2.411-.163.04 2.216.898 3.443 3.31 3.443s4.087-.698 5.641-1.68zm-8.62-5.204c.655.04 1.31.082 1.878.082 2.29 0 4.208-1.145 4.208-3.28 0-1.064-.614-1.802-1.878-1.802-2.249 0-3.634 2.134-4.208 5zM407.941 39.014l-2.614 3.36c-1.554-.941-2.945-1.436-4.661-1.436-1.433 0-2.534.698-2.534 1.884 0 .982.98 1.517 2.453 2.046 2.945 1.064 6.046 2.378 6.046 5.942 0 4.838-4.087 7.258-9.032 7.258-3.148 0-5.844-.78-7.931-2.623l2.047-3.767c1.837 1.477 4.411 1.884 5.762 1.884 1.554 0 2.905-.576 2.905-1.884 0-1.105-1.392-1.68-2.858-2.175-2.574-.86-5.559-2.257-5.559-5.699 0-4.675 3.634-7.297 8.579-7.297 2.945 0 5.479.9 7.397 2.5v.007zM15.396 33.581c3.33 0 6.06-2.737 6.06-6.07 0-3.335-2.73-6.072-6.06-6.072-3.33 0-6.06 2.737-6.06 6.071 0 3.334 2.73 6.071 6.06 6.071z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#063C58",
                        d: "M19.665 34.473c-1.5.888-3.06 1.694-4.688 2.406C9.519 39.257 1.601 40.795.217 47.72A11.339 11.339 0 000 50.01c0 5.651 3.148 9.23 7.58 10.808a5.655 5.655 0 01-2.703-4.838 5.693 5.693 0 015.689-5.705c3.702 0 5.715 3.09 6.688 7.596.52 2.425.743 5.258.756 8.239 0-.027 2.007-.691 2.196-.772.79-.353 1.547-.773 2.263-1.26a13.696 13.696 0 003.5-3.51c1.89-2.779 2.823-6.085 3.634-9.31 2.364-9.46 3.877-19.061 5.269-28.704l.284-1.856c.02-.156.007-.563.108-.698-4.344 5.766-9.451 10.835-15.592 14.48l-.007-.007z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_1_260)",
                        d: "M35.92 0l3.228 6.56 7.215 1.05-5.222 5.108 1.236 7.21-6.458-3.408-6.451 3.408 1.23-7.21-5.223-5.109 7.222-1.05L35.919 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_1_260",
                        x1: "25.475",
                        x2: "46.363",
                        y1: "9.961",
                        y2: "9.961",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F7941D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFCA40"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_1_260",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H408V67H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var logo = (TopBusinessQuotesLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/topBusinessQuotesWrapper.tsx












function TopBusinessQuotesWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyPolicy["default"], {
                    category: "Business",
                    domain: "TopBusinessQuotes.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(termsAndConditions["default"], {
                    category: "Business",
                    domain: "TopBusinessQuotes.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Inter', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "all your business needs in one place",
                        phoneNumberColor: "#063C58",
                        iconColor: "#063C58",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-6vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer["default"], {
                        bgColor: "#F2F2F2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_modal["default"], {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon["default"], {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 31701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67379);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66081);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75094);








const yearNow = new Date();
function Footer({ textColor , bgColor , addCcpaPrivacyNotice  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_2__/* .useModal */ .d)();
    const { domain , pageType , locale , defaultLocale , domainNameTranslation  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const { visitDetails , routeConfig , category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const privacyPolicyLabel = category?.config?.privacyPolicyLabel ?? category?.parentCategory?.config?.privacyPolicyLabel;
    const disclaimerNote = domain?.config?.disclaimerNote ?? null;
    let contactUsLink = null;
    if (visitDetails?.trafficSourceNetwork?.toLowerCase() === "outbrain" || category?.slug === "home-security" || domain?.name === "bestcontractors.com") {
        contactUsLink = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "cursor-pointer",
            href: "/contact-us",
            children: "Contact Us"
        });
    }
    let footerLinks = [
        {
            title: domain?.translations?.[`${domainNameTranslation}_TermsConditions`] ?? "Terms & Conditions",
            onClick: ()=>setModal({
                    active: true,
                    content: "terms"
                })
        },
        {
            title: privacyPolicyLabel || domain?.translations?.[`${domainNameTranslation}_PrivacyPolicy`] || "Privacy Policy",
            onClick: ()=>setModal({
                    active: true,
                    content: "privacy"
                })
        },
        // only show partner-with-us when its not on the partner-with-us page
        ...pageType !== "partner-with-us" ? [
            {
                title: domain?.translations?.[`${domainNameTranslation}_PartnerWithUs`] ?? "Partner with Us",
                href: locale === (defaultLocale ?? "en") ? "/partner-with-us" : `/${locale}/partner-with-us`
            }, 
        ] : [], 
    ];
    if (domain?.config?.isBranded) {
        footerLinks = footerLinks.filter((link)=>link.title !== "Partner with Us");
    }
    const ccpaTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "custom-domain-ccpa-privacy-notice" || textBlock.position === "custom-category-ccpa-privacy-notice");
    if (addCcpaPrivacyNotice || ccpaTextBlock) {
        footerLinks.push({
            title: "CCPA Privacy Notice",
            onClick: ()=>setModal({
                    active: true,
                    content: "ccpaPrivacyNotice"
                })
        });
    }
    (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__/* .injectDoNotSellInFooter */ .Du)({
        footerArray: footerLinks,
        pageType: pageType,
        trafficSource: visitDetails?.trafficSource,
        hideDoNotSell: domain.config?.hideDoNotSell,
        domain: domain,
        visitDetails: visitDetails,
        domainNameTranslation: domainNameTranslation,
        locale: locale,
        defaultLocale: defaultLocale,
        routeConfig: routeConfig
    });
    const variables = routeConfig?.config?.footer?.variables;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        style: {
            color: textColor,
            backgroundColor: bgColor,
            ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_5__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
        },
        className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footer)}  text-center lg:px-6 lg:py-0`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper)} max-w-7xl mx-auto`,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inner)} lg:flex lg:justify-between lg:items-center flex-row-reverse ${!bgColor ? "border-t" : ""} lg:mx-auto px-4 lg:px-0 py-6 pb-36 lg:py-4 ltrStyle`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `footer-menu ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["footer-menu"])}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "flex justify-center flex-col md:flex-row mb-3 lg:mb-0 children:last:border-r-0 ltrStyle",
                            children: [
                                footerLinks.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: `px-2 pb-2 md:pb-0 font-medium lg:font-light text-sm lg:leading-4 ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"])} `,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: " cursor-pointer",
                                            onClick: item.onClick,
                                            href: item.href,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: item.title
                                            })
                                        })
                                    }, index)),
                                contactUsLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: `px-2 font-medium lg:font-light text-sm lg:leading-4 ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"])} `,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: contactUsLink
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-light text-sm",
                        children: disclaimerNote ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__/* .replacePlaceholders */ .wT)(disclaimerNote)
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "\xa9"
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: yearNow.getFullYear()
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: `https://${domain.name}`,
                                    children: domain.niceName
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 18740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90021);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79961);






function Modal({ children , closeIcon , width , active , backdropClosable , onClose , modalStyles , bodyStyles , header , modalClassName , wrapperClassName , pageBuilderVariables , closeButtonClassName , overflow , activeCloseOnEscButton , fontFamilyAsProp  }) {
    const { routeConfig , locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const { 0: mounted , 1: setMounted  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: animation , 1: setAnimation  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const startAnimation = ()=>{
        setTimeout(()=>{
            setAnimation(true);
        }, 100);
    };
    const resetAnimation = ()=>{
        setAnimation(false);
    };
    const handleEsc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((event)=>{
        if (event.key === "Escape") {
            onClose(); // close modal
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (mounted) {
            if (active) {
                if (activeCloseOnEscButton) {
                    document.addEventListener("keydown", handleEsc);
                }
                document.getElementsByTagName("html")[0].classList.add("overflow-hidden");
                document.body.classList.add("overflow-hidden");
                if (window.innerWidth > 1024) {
                    document.body.style.width = "calc(100% - 15px)";
                }
                startAnimation();
            } else {
                if (activeCloseOnEscButton) {
                    document.removeEventListener("keydown", handleEsc);
                }
                document.getElementsByTagName("html")[0].classList.remove("overflow-hidden");
                document.body.classList.remove("overflow-hidden");
                document.body.style.width = "";
                resetAnimation();
            }
        }
        return ()=>{
            if (activeCloseOnEscButton) {
                document.removeEventListener("keydown", handleEsc);
            }
            document.getElementsByTagName("html")[0].classList.remove("overflow-hidden");
            document.body.classList.remove("overflow-hidden");
            document.body.style.width = "";
            resetAnimation();
        };
    }, [
        active
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setMounted(true);
    }, []);
    const getStyleObject = ()=>{
        return {
            ...pageBuilderVariables ? {
                ...pageBuilderVariables
            } : {},
            ...fontFamilyAsProp ? {
                fontFamily: fontFamilyAsProp
            } : routeConfig ? {
                fontFamily: (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFinalFontFamily */ .XR)(routeConfig, locale)
            } : {}
        };
    };
    if (mounted) {
        return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper)} ${active ? "flex" : "hidden"} ${wrapperClassName ?? ""}`,
                style: getStyleObject(),
                children: [
                    active && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: backdropClosable ? onClose : undefined,
                        className: (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().backdrop)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modal)} ${wrapperClassName ? (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[wrapperClassName] : ""} 
                        ${modalClassName ?? ""}
                        ${overflow && overflow === "visible" ? (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["overflow-visible"]) : ""}
                        
                        duration-500 transition-all ease-in-out transform ${animation ? "-translate-y-0 opacity-100" : "-translate-y-10 opacity-0"}`,
                        style: {
                            width: width ? typeof width === "string" ? `${width}px` : width : "520px",
                            maxWidth: "calc(100vw - 32px)",
                            pointerEvents: "auto",
                            ...modalStyles
                        },
                        children: [
                            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: header
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().body)} `,
                                style: bodyStyles,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: onClose,
                                        type: "button",
                                        "aria-label": "Close",
                                        className: `${closeButtonClassName} ${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["close-button"])}`,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "close-icon",
                                            children: closeIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            height: "100%"
                                        },
                                        children: children
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }), document.body);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 69655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CloseIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "47",
        height: "47",
        fill: "none",
        viewBox: "0 0 47 47",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M45.359 5.447A3.252 3.252 0 0045.35.85l.106.106a3.256 3.256 0 00-4.597-.009L23.865 17.941a1.003 1.003 0 01-1.424 0L5.447.947A3.252 3.252 0 00.85.956L.956.85a3.256 3.256 0 00-.009 4.597l16.994 16.994a1.003 1.003 0 010 1.424L.947 40.859a3.252 3.252 0 00.009 4.597L.85 45.35a3.256 3.256 0 004.597.009l16.994-16.994a1.003 1.003 0 011.424 0l16.994 16.994a3.252 3.252 0 004.597-.009l-.106.106a3.256 3.256 0 00.009-4.597L28.365 23.865a1.003 1.003 0 010-1.424L45.359 5.447z"
        })
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 66081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"footer_menu-item__PuRF4","footer":"footer_footer__4Qyt9","inner":"footer_inner__ZnSSe","wrapper":"footer_wrapper__vsYp1","footer-menu":"footer_footer-menu__cG5mD"};

/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 14777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","legal":"legal_legal__qUt4s","ccpaMainContainer":"legal_ccpaMainContainer__EgCgv","decimalStyleOnlyLi":"legal_decimalStyleOnlyLi__qBRw_","decimalStyle":"legal_decimalStyle__ostDo","alphaStyle":"legal_alphaStyle__B5bJA","timeStyle":"legal_timeStyle__bx7dw"};

/***/ }),

/***/ 90021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__byYo9","overflow-visible":"modal_overflow-visible__Hw4yh","wrapper":"modal_wrapper__SOjyg","close-button":"modal_close-button__gm_NI","modal":"modal_modal__yslIq","body":"modal_body__ivFOU","header":"modal_header__nr_by","disclaimerModal":"modal_disclaimerModal__YCenG"};

/***/ })

}]);